import * as React from 'react';
import { Omit } from 'react-router';

type DivProps = JSX.IntrinsicElements['div'];
type FormGroupProps = Omit<DivProps, 'children'> & { children: React.ReactNode };
export default function FormGroup({ children, className, ...props }: FormGroupProps): JSX.Element {
    return (
        <div className={`form-group ${className}`} {...props}>
            {children}
        </div>
    );
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Alerts/form/FormGroup.tsx